import { render, staticRenderFns } from "./PopupAlertDetail.vue?vue&type=template&id=70927f93&scoped=true"
import script from "./PopupAlertDetail.vue?vue&type=script&lang=js"
export * from "./PopupAlertDetail.vue?vue&type=script&lang=js"
import style0 from "./PopupAlertDetail.vue?vue&type=style&index=0&id=70927f93&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70927f93",
  null
  
)

export default component.exports